export default __webpack_public_path__ + "static/whatsapp-icon-50740dc9904c67324305d6ed3a356feb.png";